export enum CheckoutPagesEnum {
    USER_INFO_PAGE = "USER_INFO_PAGE",
    STATE_SELECT_PAGE = "STATE_SELECT_PAGE",
    PRODUCT_FAMILY_SELECT_PAGE = "PRODUCT_FAMILY_SELECT_PAGE",
    PLAN_SELECT_PAGE = "PLAN_SELECT_PAGE",
    GRADE_CURRICULUM_PAGE = "GRADE_CURRICULUM_PAGE",
    CHARGE_SELECT_PAGE = "CHARGE_SELECT_PAGE",
    ADDON_SELECT_PAGE = "ADDON_SELECT_PAGE",
    INTERNATIONAL_ADDON_PAGE = "INTERNATIONAL_ADDON_PAGE",
    PAYMENT_PAGE = "PAYMENT_PAGE",
    PAYMENT_SUCCESS_PAGE = "PAYMENT_SUCCESS_PAGE",
    STUDENT_SELECTION_PAGE = "STUDENT_SELECTION_PAGE",
    CREATE_NEW_STUDENT_PAGE = "CREATE_NEW_STUDENT_PAGE"
}
